import { apiHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const reportService = {
    getAllReports,
    getReport,
    getReportByReferenceNumber,
    updateReport,
    createReport,
    updateReportStatus
};

const MODULE = {
    REPORT: 'new-reports',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllReports(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company_location_uuid'] = sessionHelper.getStaffLocationUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.REPORT}`, requestOptions)
}

export function getReport(id) {
    return apiHelper(API_URL).get(`/${MODULE.REPORT}/${id}`)
}

export function getReportByReferenceNumber(referenceNumber) {
    return apiHelper(API_URL).get(`/${MODULE.REPORT}/${referenceNumber}/reference_number`)
}

export function updateReport(data) {

    const requestOptions = {
        remark: data.remark,
        mileage: data.mileage,
    }

    return apiHelper(API_URL).put(`/${MODULE.REPORT}/${data.id}`, requestOptions)
}

export function createReport(data) {

    const requestOptions = {
        customer_vehicle_uuid: data.vehicleID,
        remark: data.remark,
        mileage: data.mileage,
        report_type: data.reportType,
        report_uuid: data.reportID,
    }

    return apiHelper(API_URL).post(`/${MODULE.REPORT}`, requestOptions)
}

export function updateReportStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.REPORT}/${data.id}`, requestOptions)

}